module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm03"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/fm04",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocft"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART I: Providing Sanctuary")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("A Curriculum for Congregations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Lesson 1")]), _vm._v(" Honor Thy Mother and Father")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Lesson 2")]), _vm._v(" ‘Til Death Do Us Part")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Lesson 3")]), _vm._v(" Gifts to Give")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Lesson 4")]), _vm._v(" Ways to Serve")])]), _vm._v(" "), _c('p', {
    staticClass: "tocft"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART II: Seeking Sanctuary")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("Caring for a Parent")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Lesson 1")]), _vm._v(" Role Reversal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Lesson 2")]), _vm._v(" Loneliness and Isolation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Lesson 3")]), _vm._v(" Asking for Help")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Lesson 4")]), _vm._v(" Self-Care")])]), _vm._v(" "), _c('p', {
    staticClass: "tocft"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART III: Seeking Sanctuary")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("Support for Spouses")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Lesson 1")]), _vm._v(" God with Us")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Lesson 2")]), _vm._v(" The Truth Will Set You Free")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Lesson 3")]), _vm._v(" Ways to Express Commitment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("Lesson 4")]), _vm._v(" Finding Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "tocft"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART IV: Creating Sanctuary")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Designing a Dementia Caregiver Ministry")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Final Word")])]), _vm._v(" "), _c('p', {
    staticClass: "tocft"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm03",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 72
// module chunks = 0